import moment from 'moment';
import _ from 'lodash';
/**
 * Format a number to a better display
 *
 * @param value
 * @param unit
 * @return {string}
 */
export const displayNumber = (value, unit = 'FCFA') => {
	return Number(value).toLocaleString('fr') + ' ' + unit;
};
export const parseNameAndSurname = (name, surname) => {
    if (_.isUndefined(name) || _.isNull(name))
        return '';
    name = name.toUpperCase();

    if (_.isUndefined(surname) || _.isNull(surname)){
        return name;
    }else{
        if (surname.length>0){
            // surname = surname.toLowerCase();
            // surname = surname.charAt(0).toUpperCase() + (surname.substring(1, surname.length)).toLowerCase();
            surname = _.startCase(surname);
        }
    }

    return name+ ' ' +surname;


};

export const getBirthDateOrBornAroundYear = (birthDate, bornAround) => {
    if(birthDate && birthDate !== '') return {
        message: '',
        date: birthDate
    };
    else if(bornAround && bornAround !== '') return {
        message: 'message.bornAround',
        date: bornAround
    };
    return null;
};


/**
 * Parse a string date to an array of number so that it'll be readable to moment js
 *
 * @param str
 * @returns {number[]}
 */
const parseStringDateToArray = str => {
    // Since str is equal to 'DD-MM-YYYY HH:mm'
    return [
        Number(str.substring(6, 10)), // years
        Number(str.substring(3, 5)), // months
        Number(str.substring(0, 2)), // days
        Number(str.substring(11, 13)), // hours
        Number(str.substring(14, 16)) // minutes
    ];
};


/**
 * Customize the sort of date column
 *
 * @param aRow
 * @param bRow
 * @param key
 * @returns {null|number}
 */
export function customSortFunction(aRow, bRow, key) {

    // Only handle the case where the key is the date
    if (key === 'date' || key === 'createdAt') {
        const a = moment(parseStringDateToArray(aRow[key]));
        const b = moment(parseStringDateToArray(bRow[key]));

        return a.diff(b) > 0 ? 1 : a.diff(b) < 0 ? -1 : 0;
    }

    // Return null so that the built-in sort-compare function will handle the thing
    return null;
}

export function getUUID(){
    $(function() {
        $.ajax({
            url: "https://www.uuidgenerator.net/api/version4",
            type: "GET",
            // Request body
            data: "{body}",
        })
            .done(function(data) {
                return data
            })
            .fail(function() {
            });
    });
}

export function formattedDate(date) {
    if (moment(date).isValid()) {
        return moment(date).format("DD-MM-YYYY");
    } else {
        return date;
    }
}